// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'

// We don't render route components (we use $route in App.vue), but
// Vue Router prefers a component. Use tiny stubs so navigation is valid.
const Empty = { template: '<div />' }

export default createRouter({
  history: createWebHistory(), // simpler & safe
  routes: [
    { path: '/', redirect: '/buy' },
    { path: '/buy',   name: 'buy',   component: Empty },
    { path: '/stake', name: 'stake', component: Empty },
    { path: '/dev',   name: 'dev',   component: Empty },
  ],
  scrollBehavior: () => ({ top: 0 }),
})
